/**
 *
 * @author Ray <https://github.com/XiaoDaiGua-Ray>
 *
 * @date 2023-11-30
 *
 * @workspace ray-template
 *
 * @remark 今天也是元气满满撸代码的一天
 */

import { getVariableToRefs, setVariable } from '@/global-variable'

export function useSpinning() {
  const globalSpinning = getVariableToRefs('globalSpinning')
  const pageSpinning = getVariableToRefs('pageSpinning')

  function setGlobalSpinning(loading: boolean) {
    setVariable('globalSpinning', loading)
  }

  function setPageSpinning(loading: boolean) {
    setVariable('pageSpinning', loading)
  }

  return {
    globalSpinning,
    pageSpinning,

    setGlobalSpinning,
    setPageSpinning,
  }
}

export type UseSpinningReturnType = ReturnType<typeof useSpinning>
